<template>
  <div
    class="lottery-list"
    :style="module.containerStyle"
    :data-tangram-module-id="module.id"
  >
    <div
      class="winner-container"
      :style="{
        backgroundImage: `url(${backgroundImage})`
      }"
    >
      <div
        :style="{
          width: screenWidth * 0.9 + 'px',
          height: screenWidth * 0.6 + 'px'
        }"
      >
        <div class="winner-title">中奖名单</div>
        <carousel
          v-if="module.lotteryList.length"
          class="winner-list-container"
          :arr-length="module.lotteryList.length"
          :ani-time="500"
          :delay-time="1500"
          :item-height="0.64"
        >
          <div slot="lamps" class="winner-list">
            <div
              v-for="(item, index) in module.lotteryList"
              :key="index"
              class="winner-item"
            >
              <div class="item-left">
                {{ item.companyName }}
              </div>
              <div class="item-right">
                {{ item.prizeName }}
              </div>
            </div>
          </div>
        </carousel>
        <div v-if="module.lotteryList.length === 0" class="winner-list-empty">
          敬请期待
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Carousel from '../components/Carousel'
import { WIDTH } from '@/defines/env'
import { ossImage } from '@/utils/oss_image'

export default {
  name: 'LotteryList',
  components: {
    Carousel
  },
  props: {
    module: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      screenWidth: WIDTH,
      backgroundImage: ossImage({
        src: this.module.backgroundImage,
        width: WIDTH * 2
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.winner-container {
  margin: 0 auto;
  padding-top: 10%;

  background-position: top;

  background-size: 100% 100%;
  & > div {
    margin: 0 auto;
  }
  .winner-title {
    height: 16%;

    font-size: 0.32rem;
    text-align: center;
    color: $c-lottery-list;
  }
  .winner-list-container {
    position: relative;

    width: 70%;
    height: 2.54rem;
    margin: 0 auto;
    overflow: hidden;
    .winner-list {
      position: absolute;

      width: 100%;
    }
  }
  .winner-item {
    display: -webkit-box;

    height: 0.64rem;

    font-size: 0.28rem;
    line-height: 0.64rem;
    color: $c-lottery-list;
    .item-left {
      display: -webkit-box;

      overflow: hidden;

      line-height: 0.64rem;
      font-weight: normal;
      font-weight: 500;
      white-space: normal;
      -webkit-box-flex: 1;
      /* autoprefixer: off */
      -webkit-box-orient: vertical;
      /* autoprefixer: on */
      -webkit-line-clamp: 1;
      text-overflow: ellipsis;
      word-break: break-all;

      color: inherit;
    }

    .item-right {
      color: inherit;
    }
  }
  .winner-list-empty {
    height: 16%;
    margin-top: 1.1rem;

    font-size: 0.32rem;
    text-align: center;
  }
}
</style>
